import { MENUS_ITEMS } from '@/constants/tabs';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function PagesMenu() {
  const router = useRouter();
  const t = useTranslations('Footer');

  return (
    <nav className="pages-menu">
      <ul>
        {MENUS_ITEMS.map((item) => {
          const href = item.url;
          const isActive = router.asPath === href || (href && router.asPath.endsWith(href));
          const displayTitle = t(item.titleKey);

          return (
            <li key={item.titleKey} className={isActive ? 'active' : undefined}>
              <Link href={href}>{displayTitle}</Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
